const dev = {
  env: process.env.REACT_APP_ENV,
  url: {
     AUTH_URL: 'http://localhost:5001'
  }
}

const qa = {
  env: process.env.REACT_APP_ENV,
  url: {
    AUTH_URL: 'https://cipla-qa.cimmra.com'
  }
}

const uat = {
  env: process.env.REACT_APP_ENV,
  url: {
    AUTH_URL: 'https://invoicing-uat.cipla.com'
  }
}

const prod = {
  env: process.env.REACT_APP_ENV,
  url: {
    AUTH_URL: 'https://invoicing.cipla.com'
  }
}

function getEnv(env) {
  if (env === "development") return dev
  if (env === "qa") return qa
  if (env === "uat") return uat
  if (env === "prod") return prod
  return qa
}

export const environment = getEnv(process.env.REACT_APP_ENV)
